<template>
    <CompassTooltip :arrow="false">
        <template #content>
            <span>{{ file.name + '.' + file.extension }}</span>
        </template>
        <button :class="classes" class="email-attachment-link" @click="handleClick">
            <svg class="file-icon" :viewBox="fileType.viewBox" v-html="fileType.src"></svg>
            <span class="email-attachment-link__label">{{ truncatedText }}</span>
        </button>
    </CompassTooltip>
</template>
<script>
import { acceptedFileTypes } from 'Config/authenticated/dictionary/emailAttachments';
import { icons } from 'vcomponents/email/EmailAttachmentFileTypes';

export default {
    props: {
        file: {
            type: Object,
            required: true,
        },
        isMocked: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'medium',
            validator: (value) => ['small', 'medium'].includes(value),
        },
    },
    computed: {
        formatedFileExtension() {
            return this.file.extension.toLowerCase();
        },
        classes() {
            return [this.isMocked ? 'is-mocked' : '', `email-attachment-link--${this.size}`];
        },
        fileIcon() {
            const isKnownFileType = Object.keys(acceptedFileTypes).includes(
                this.formatedFileExtension,
            );
            return isKnownFileType ? acceptedFileTypes[this.formatedFileExtension].icon : 'default';
        },
        fileType() {
            return icons.find((file) => file.id === this.fileIcon);
        },
        isImageFile() {
            const imageFileExtensions = Object.entries(acceptedFileTypes)
                .filter(([key, value]) => value.icon === 'image')
                .map(([key]) => key);

            return imageFileExtensions.includes(this.formatedFileExtension);
        },
        canOpenInNewTab() {
            return this.isImageFile || this.formatedFileExtension === 'pdf';
        },
        truncatedText() {
            const maxLength = 25;
            if (this.file && this.file.name.length > maxLength) {
                return this.file.name.substring(0, maxLength) + '...' + this.file.extension;
            }
            return this.file.name + '.' + this.file.extension;
        },
    },
    methods: {
        handleClick() {
            if (!this.isMocked) {
                if (this.canOpenInNewTab) {
                    window.open(this.file.public_link + '&display=Y', '_blank');
                } else {
                    window.open(this.file.public_link, '_blank');
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.email-attachment-link {
    align-items: center;
    background: transparent;
    border: 1px solid var(--colors-common-border-default);
    border-radius: 50px;
    color: var(--colors-common-text-subtle-default);
    cursor: pointer;
    display: inline-flex;
    font-family: 'Proxima Nova';
    font-size: 14px;
    font-weight: 600;
    gap: var(--spacing-0);
    line-height: 20px;
    max-width: 180px;
    padding: var(--spacing-0) var(--spacing-3);

    &--small {
        padding: var(--spacing-0) var(--spacing-1);
    }

    &__label {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .file-icon {
        flex-shrink: 0;
        height: 16px;
        width: 16px;
    }
}
.is-mocked,
.email-attachment-link {
    cursor: auto;
}
</style>
